import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import { api } from './api';

interface AlertRow {
    id: number;
    server_id: number | null;
    server_name: string;
    alert_type: string;
    severity: string;
    message: string;
    channels_sent: string;
    channels_failed: string;
    created_at: string;
}

const TYPE_LABEL: Record<string, string> = {
    down: '🔴 Недоступен', recovery: '🟢 Восстановлен',
    cpu: '🔥 CPU', ram: '🧠 RAM', disk: '💾 Диск',
};

function fmtDt(iso: string): string {
    const d = new Date(iso + (iso.endsWith('Z') ? '' : 'Z'));
    return d.toLocaleString('ru-RU');
}

export default function Alerts() {
    const [rows, setRows]   = useState<AlertRow[]>([]);
    const [loading, setLoading] = useState(true);

    const load = () => {
        api.get<AlertRow[]>('/alerts?limit=200')
            .then(setRows)
            .catch(() => {})
            .finally(() => setLoading(false));
    };

    useEffect(() => { load(); }, []);

    const clear = async () => {
        if (!window.confirm('Очистить весь журнал оповещений?')) return;
        try { await api.del('/alerts'); setRows([]); }
        catch (e: any) { alert(e.message); }
    };

    return (
        <div className="app-layout">
            <Sidebar />
            <main className="main-content">
                <header className="page-header">
                    <h1>Оповещения</h1>
                    <div className="header-actions">
                        <button className="btn-secondary" onClick={load}>Обновить</button>
                        <button className="btn-secondary btn-danger-outline" onClick={clear}>
                            Очистить журнал
                        </button>
                    </div>
                </header>

                {loading ? (
                    <div className="loading-screen">Загрузка...</div>
                ) : rows.length === 0 ? (
                    <div className="empty-state">
                        <div className="empty-icon">🔔</div>
                        <h2>Оповещений пока нет</h2>
                        <p>Здесь появятся все сработавшие алерты</p>
                    </div>
                ) : (
                    <div className="table-wrap">
                        <table className="servers-table">
                            <thead>
                                <tr>
                                    <th>Время</th>
                                    <th>Сервер</th>
                                    <th>Событие</th>
                                    <th>Сообщение</th>
                                    <th>Отправлено</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map(r => (
                                    <tr key={r.id}>
                                        <td className="td-time">{fmtDt(r.created_at)}</td>
                                        <td>{r.server_name}</td>
                                        <td>
                                            <span className={`sev-badge sev-${r.severity}`}>
                                                {TYPE_LABEL[r.alert_type] ?? r.alert_type}
                                            </span>
                                        </td>
                                        <td>{r.message}</td>
                                        <td className="td-channels">
                                            {r.channels_sent || '—'}
                                            {r.channels_failed && (
                                                <span className="txt-err"> (ошибка: {r.channels_failed})</span>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </main>
        </div>
    );
}
